import examService from '@/services/exam';
import orderService from '@/services/order.js';
import dayjs from 'dayjs';
const isSameOrAfter = require('dayjs/plugin/isSameOrAfter');
dayjs.extend(isSameOrAfter);
import {removeLocalData} from '@/lib/base/localData';
import {PAYMENT_METHODS} from '@/constant/paymentMethods.js';

/**
 * @returns {Object} initialize state
 */
const initialState = () => {
  return {
    unfinishedExam: null,
    examList: null,
    unfinishedExamItem: null,
    examQuestions: null,
    currentExam: null,
    currentExams: [],
  };
};
const state = initialState();

const getters = {
  unfinishedExam(state) {
    return state.unfinishedExam;
  },
  examList() {
    return state.examList;
  },
  unfinishedExamItem() {
    return state.unfinishedExamItem;
  },
  examQuestions() {
    return state.examQuestions;
  },
};

const actions = {
  async getUnfinishedExam({commit}) {
    try {
      const result = await examService.getExamByToken();
      commit('setUnfinishedExam', result); // 計入未完成的檢定

      const {list} = result;
      commit('setExamList', list); // 計入檢定項目列表

      const unStartItem = list.findIndex((item) => {
        return !item.isStart;
      });
      // 計入檢定項目的進度
      if (unStartItem === 0) {
        commit('setUnfinishedExamItem', list[0]);
      } else if (unStartItem < 0) {
        commit('setUnfinishedExamItem', list[list.length - 1]);
      } else {
        commit('setUnfinishedExamItem', list[unStartItem - 1]);
      }

      // 計入檢定項目做題的題目（正在進行中的）
      if (unStartItem === 0 && list[0].isTsume && list[0].questions) {
        commit('setExamQuestions', list[0].questions);
      } else if (
        unStartItem > 0 &&
        list[unStartItem - 1].isTsume &&
        list[unStartItem - 1].questions
      ) {
        commit('setExamQuestions', list[unStartItem - 1].questions);
      } else {
        commit('setExamQuestions', null);
      }

      return result;
    } catch (error) {
      removeLocalData('examJwt');
      return error;
    }
  },
  async setNextExamItem({commit, dispatch}, typeNo) {
    // 計入下一個檢定項目的進度
    commit('setUnfinishedExamItem', state.examList[typeNo]);
    commit('setExamItemStart', typeNo);
    commit('setExamItemOver', typeNo - 1);
    // 計入檢定項目做題的題目（正在進行中的）
    if (state.examList[typeNo].isTsume) {
      commit('setExamQuestions', state.examList[typeNo].questions);
      await dispatch('updateExamTsume', {typeNo, no: 0});
    } else {
      commit('setExamQuestions', null);
      await dispatch('updateExamGame', {typeNo});
    }
  },
  async updateExamTsume({commit}, {typeNo, no}) {
    const apiData = {
      startAt: dayjs(),
      examId: state.unfinishedExam.id,
      tsumeId: state.examList[typeNo].questions[no].id,
    };
    await examService.updateExamTsume(apiData);
    commit('setExamQuestionStart', {no, startAt: dayjs()});
  },
  async updateExamGame({commit}, {typeNo}) {
    try {
      const apiData = {
        startAt: dayjs(),
        examId: state.unfinishedExam.id,
        gameId: state.examList[typeNo].id,
      };
      await examService.updateExamGame(apiData);
      commit('aiGame/setGameData', state.examList[typeNo], {root: true});
      commit('setExamItemStart', typeNo);
    } catch (error) {
      this.$Message.error(error);
    }
  },
  async setGameTimeout({commit}, {typeNo}) {
    const apiData = {
      examId: state.unfinishedExam.id,
      gameId: state.examList[typeNo].id,
    };
    const result = await examService.setGameTimeout(apiData);
    commit('aiGame/setGameData', state.examList[typeNo], {root: true});
    commit('setExamItemOver', typeNo);
    return result;
  },
  async getCurrentExams({commit}, userId) {
    const {rows} = await actions.getExams(null, {userId, limit: 20, offset: 0});
    commit('setCurrentExams', rows);
  },
  async getExams(_, {userId, limit, offset}) {
    try {
      const apiData = {
        playerUserId: userId,
        limit,
        offset,
        isPaid: true,
        isOrderByEventStartAt: true,
        isDesc: true,
        paymentMethods: [
          PAYMENT_METHODS.EXAM_FORESTAGE,
          PAYMENT_METHODS.EXAM_BACKSTAGE_MULTIPLE,
        ],
      };
      const result = await orderService.getOrders(apiData);
      return result;
    } catch (error) {
      console.log('get current exams fail');
    }
  },
  async getExamRealCertification(_, {examId}) {
    try {
      const apiData = {
        examId,
        limit: 1,
        offset: 0,
        isPaid: true,
        isDesc: true,
        paymentMethods: [
          PAYMENT_METHODS.CERTIFICATION_FORESTAGE,
          PAYMENT_METHODS.CERTIFICATION_BACKSTAGE_MULTIPLE,
        ],
      };
      const result = await orderService.getOrders(apiData);
      return result?.rows[0];
    } catch (error) {
      console.log('getExamRealCertification fail');
    }
  },
};

const mutations = {
  setUnfinishedExam(state, data) {
    state.unfinishedExam = data;
  },
  setExamList(state, data) {
    state.examList = data;
  },
  setUnfinishedExamItem(state, data) {
    state.unfinishedExamItem = data;
  },
  setExamQuestions(state, data) {
    state.examQuestions = data;
  },
  setCurrentExam(state, data) {
    state.currentExam = data;
  },
  setCurrentExams(state, data) {
    state.currentExams = data;
  },
  setExamQuestionStart(state, {no, startAt}) {
    if (no - 1 >= 0) state.examQuestions[no - 1].isOver = true;
    state.examQuestions[no].isStart = true;
    state.examQuestions[no].startAt = startAt;
  },
  setExamItemStart(state, typeNo) {
    state.examList[typeNo].isStart = true;
  },
  setExamItemOver(state, typeNo) {
    state.examList[typeNo].isOver = true;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
